/* A contents list for the store policies.

   Shopify renders policy pages itself, so there is no template to add this to and no
   section to configure. The headings are already on the page; this reads them and
   builds the jump list from them, which means it cannot fall out of step with the
   policy text the way a hand-written list would.

   Nothing is inserted when there are fewer than three headings — a short policy does
   not need navigating — and nothing at all happens without JavaScript, which leaves
   the page exactly as it is today. */

(function () {
  var container = document.querySelector('.shopify-policy__container');
  var body = container && container.querySelector('.shopify-policy__body');
  if (!body) return;

  var headings = body.querySelectorAll('h2');
  if (headings.length < 3) return;

  var slugged = Object.create(null);
  var list = document.createElement('ul');
  list.className = 'wn-policy__toc__list';

  Array.prototype.forEach.call(headings, function (heading, index) {
    var text = (heading.textContent || '').trim();
    if (!text) return;

    if (!heading.id) {
      var slug =
        text
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '') || 'section';
      // Two headings can reduce to the same slug, and a duplicate id sends every
      // link to the first of them.
      if (slugged[slug]) {
        slug += '-' + index;
      }
      slugged[slug] = true;
      heading.id = slug;
    }

    var item = document.createElement('li');
    var link = document.createElement('a');
    link.className = 'wn-policy__toc__link';
    link.href = '#' + heading.id;
    link.textContent = text;
    item.appendChild(link);
    list.appendChild(item);
  });

  if (!list.children.length) return;

  var nav = document.createElement('nav');
  nav.className = 'wn-policy__toc';
  nav.setAttribute('aria-label', 'Contents');

  var title = document.createElement('p');
  title.className = 'wn-policy__toc__title';
  title.textContent = 'Contents';

  nav.appendChild(title);
  nav.appendChild(list);
  container.insertBefore(nav, body);
})();
